import { useQuery } from "react-query";
import { RelatorioDemonstrativoReceitaDespesaAnualPdfResponse, FiltroRelatorioReceitaDespesaAnual } from "../typings";
import { AxiosError } from "axios";
import http from "infra/http";

export function useRelatorioDemonstrativoReceitaDespesaAnualPdf(query?: FiltroRelatorioReceitaDespesaAnual) {
  return useQuery<RelatorioDemonstrativoReceitaDespesaAnualPdfResponse, AxiosError>(
    ['/v1/relatorios/financeiro/demonstrativo-receita-despesa/anual/pdf', query],
    async () => {
      const {data} = await http.get('/v1/relatorios/financeiro/demonstrativo-receita-despesa/anual/pdf', {
        params: query
      })

      return data;
    },
    {
      enabled: false,
    }
  );
}

export default useRelatorioDemonstrativoReceitaDespesaAnualPdf;
